// Global error boundary — last line of defense; must render its own <html>.
"use client";

import { useEffect } from "react";

import { reportRuntimeError } from "@/lib/monitoring/runtimeError";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportRuntimeError({ source: "next-global-error", error, digest: error.digest });
  }, [error]);

  return (
    <html lang="fa" dir="rtl">
      <body className="flex min-h-dvh flex-col items-center justify-center gap-4 p-8 text-center">
        <h1 className="text-xl font-bold">خطای غیرمنتظره</h1>
        <p className="max-w-md text-sm text-zinc-600">مشکلی جدی در برنامه رخ داده است.</p>
        <button
          type="button"
          onClick={reset}
          className="rounded-md bg-zinc-900 px-4 py-2 text-sm text-white transition-colors hover:bg-zinc-700"
        >
          تلاش مجدد
        </button>
      </body>
    </html>
  );
}
